import React, { useEffect, useState } from "react";
import { Form, FormGroup, FormControl, Button } from "react-bootstrap";
// import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Create.scss";
import Draw from "./Draw";
import ColorBackgroundForm from "../components/ColorBackgroundForm";
import { colorsData } from "../components/data";
import { database, storage } from "../firebaseConfig";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";

export default function Create() {
  const [title, setTitle] = useState("");
  const [limit, setLimit] = useState("");
  const [prizeName, setPrizeName] = useState("");
  const [prizes, setPrizes] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  // const [selectedColor, setSelectedColor] = useState(colorsData[0].color);
  const [selectedTextColor, setSelectedTextColor] = useState("#4e6e66");
  // const selectedImage = colorsData.find(
  //   (colorData) => colorData.color === selectedColor
  // )?.image;
  // const [companyLogoFile, setCompanyLogoFile] = useState(null);
  // const [promoLogoFile, setPromoLogoFile] = useState(null);
  const [entryFile, setEntryFile] = useState(null);
  const navigate = useNavigate();

  // const handleColorChange = (color) => {
  //   setSelectedColor(color);
  //   document.documentElement.style.setProperty("--selected-color", color);
  // };

  // const handleTextColorChange = (color) => {
  //   setSelectedTextColor(color);
  //   document.documentElement.style.setProperty("--selected-text-color", color);
  // };

  // const handleChange = (e) => {
  //   const selectedColor = e.target.value;
  //   setSelectedColor(selectedColor);
  //   handleColorChange(selectedColor);
  // };

  const handleTitle = (event) => {
    setTitle(event.target.value);
  };

  const uploadFile = async (file) => {
    if (!file) {
      throw new Error("File is empty!");
    }

    const storageRef = ref(storage, `${title}/${file.name}`);

    try {
      let downloadUrl;

      if (
        file.type === "text/csv" ||
        file.type === "application/csv" ||
        file.type === "application/excel" ||
        file.type === "application/vnd.ms-excel"
      ) {
        // Handle CSV file upload
        await uploadBytes(storageRef, file);
        console.log(`Uploaded CSV file: ${file.name}`);
        downloadUrl = await getDownloadURL(storageRef);
      } else if (file.type.startsWith("image/")) {
        // Handle image file upload
        await uploadBytes(storageRef, file);
        console.log(`Uploaded image file: ${file.name}`);
        downloadUrl = await getDownloadURL(storageRef);
      } else {
        throw new Error("Unsupported file type!");
      }

      return downloadUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };

  // const handleCompanyLogoChange = (event) => {
  //   setCompanyLogoFile(event.target.files[0]);
  // };

  // const handlePromoLogoChange = (event) => {
  //   const file = event.target.files[0];
  //   console.log(file.type);
  //   setPromoLogoFile(file);
  // };

  const handleEntryUpload = async (event) => {
    const file = event.target.files[0];
    setEntryFile(file);
    console.log(file.type);
  };

  const handleLimit = (event) => {
    setLimit(event.target.value);
  };

  const handlePrizeNameChange = (event) => {
    setPrizeName(event.target.value); // Update prizeName state when input changes
  };

  // Function to add a new prize
  const addPrize = (event) => {
    event.preventDefault(); // Prevents form submission
    const newPrize = { name: prizeName, limit: limit, winners: [] };
    setPrizes([...prizes, newPrize]);
    setPrizeName(""); // Reset prize name input
    setLimit(""); // Reset limit input
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !title ||
      // || !companyLogoFile
      !entryFile
    ) {
      alert("Please fill out all fields!");
      return;
    }

    if (prizes.length < 1) {
      alert("Please click add button to add prize name!");
      return;
    }

    try {
      const [
        // companyLogoUrl,
        //  promoLogoUrl,
        entryUrl,
      ] = await Promise.all([
        // uploadFile(companyLogoFile),
        // uploadFile(promoLogoFile),
        uploadFile(entryFile),
      ]);

      const docData = {
        title: title,
        // companyLogo: companyLogoUrl,
        // promoLogo: promoLogoUrl,
        entry: entryUrl,
        // selectedImage: selectedImage,
        // selectedTextColor: selectedTextColor,
        prizes: prizes,
      };

      await setDoc(doc(database, "Promotions", title), docData);
      console.log("Document successfully written!");
      setFormSubmitted(true);
      navigate(`/draw/${title}`);
    } catch (error) {
      console.error("Error writing document:", error);
      console.error("There was an error submitting your form!");
    }
  };

  return (
    <>
      <div
        className="app"
        // style={{ backgroundImage: `url(${selectedImage})` }}
      >
        <>
          <div className="content">
            <Form className="content-text" style={{ color: selectedTextColor }}>
              <div className="heading">
                <h1>Create Promotion!</h1>
              </div>
              <div className="formContent">
                <FormGroup className="title">
                  <p>Promotion Title</p>
                  <FormControl
                    type="text"
                    name="Title"
                    placeholder="Promotion Title"
                    value={title}
                    onChange={handleTitle}
                  />
                </FormGroup>
                {/* <FormGroup className="p-logo hidden">
                  <p className="hidden">Promotion Logo</p>
                  <FormControl
                    name="Promotion Logo"
                    type="file"
                    accept="image/*"
                    onChange={handlePromoLogoChange}
                  />
                </FormGroup>
                <FormGroup className="c-logo hidden">
                  <p className="hidden">Company Logo</p>
                  <FormControl
                    name="Company Logo"
                    type="file"
                    accept="image/*"
                    onChange={handleCompanyLogoChange}
                  />
                </FormGroup> */}
                <FormGroup className="file">
                  <p>Entries</p>
                  <FormControl
                    name="Entries"
                    type="file"
                    accept=".csv"
                    onChange={handleEntryUpload}
                  />
                </FormGroup>
                <FormGroup className="Prize">
                  <span>
                    <p>Prize Name</p>
                    <FormControl
                      name="Prize"
                      type="text"
                      value={prizeName}
                      onChange={handlePrizeNameChange}
                    />
                  </span>
                  <span>
                    <p>No of winners</p>
                    <span className="limit-button">
                      <FormControl
                        name="No of Winners"
                        type="number"
                        value={limit}
                        className="limit-input"
                        onChange={handleLimit}
                      />
                      <button
                        onClick={addPrize}
                        className="prize-button"
                        style={{ color: selectedTextColor }}
                      >
                        add
                      </button>
                    </span>
                  </span>
                </FormGroup>
                {/* <FormGroup className="color hidden" name="Background Color">
                  <p className="hidden">Background Color:</p>
                  <select
                    className="hidden"
                    value={selectedColor}
                    onChange={handleChange}
                  >
                    {colorsData.map((color) => (
                      <option key={color.color} value={color.color}>
                        {color.name}
                      </option>
                    ))}
                  </select>
                  <main className="hidden">
                    <ColorBackgroundForm
                      setSelectedTextColor={setSelectedTextColor}
                    />
                  </main>
                </FormGroup> */}
              </div>
              <Button
                type="submit"
                className="content-button"
                style={{ backgroundColor: selectedTextColor }}
                onClick={handleSubmit}
              >
                Create Draw
              </Button>
            </Form>
          </div>
        </>
      </div>
    </>
  );
}
